import React, { useEffect, useState } from 'react';
import styles from '../styles/Home.module.css';

const Activity = () => {

  const [tasks, setTasks] = useState([]);
  const [finished, setFinished] = useState([]);
  const [unfinished, setUnfinished] = useState([]);
  const [tbd, setTbd] = useState([]);
  const [screening, setScreening] = useState([]);
  
  const [batch, setBatch] = useState([]);
  const [batch_id, setBatchId] = useState(null);
  const [batchName, setBatchName] = useState('Default');

  //read the topmenu to get the selected batch
  const GetSelectedBatchName = () => {
    const selectedBatchElement = document.getElementById("SelectedBatch");
    if (selectedBatchElement) {
      return selectedBatchElement.innerHTML.trim();
    }
    return null;
  };

  
  //get all the batches 
  useEffect(() => {
    fetch(`/get_batch`)
      .then((response) => response.json())
      .then((batch) => {
        setBatch(batch);
        console.log("Batch data:", batch);
      })

  },[]);

  //function to set the batch ID currently selected IMPORTANT FOR GETTING SPECIFIC BATCH INFORMATION
  useEffect(() => {
    var BatchName
    var BatchNumber
    BatchName = GetSelectedBatchName();
    if ( BatchName === '' )
    {
      BatchName = "Default"
      BatchNumber = 1
    }
    else {console.log("FALSE")
        console.log(BatchName)}
        
    console.log("Batch Name: ", BatchName)
    for (let i = 0; i < batch.length; i += 1) {
      if (BatchName === batch[i].title){
        BatchNumber = batch[i].id
      }
    }
    
    setBatchId(BatchNumber)
    setBatchName(BatchName)
    console.log("Batch Number: ", BatchNumber)
  }, [batch]);


  //only run calls if there is a provided batch number
  useEffect(() => {
    if (!batch_id) {
      console.log("Error: No Batch ID");
      return;
    }
    Promise.all([
      fetch(`/get_battery_tasks/${batch_id}`).then((res) => res.json()),
      fetch(`/get_finished_results/${batch_id}`).then((res) => res.json()),
      fetch(`/get_unfinished_results/${batch_id}`).then((res) => res.json()),
      fetch(`/get_tbd_results/${batch_id}`).then((res) => res.json()),
      fetch(`/get_screening_results/${batch_id}`).then((res) => res.json()),
    ])
      .then(([tasks, finished, unfinished, tbd, screening]) => {
        setTasks(tasks);
        setFinished(finished);
        setUnfinished(unfinished);
        setTbd(tbd);
        setScreening(screening);
      })
      .catch((error) => console.error("Error in API calls:", error));
  }, [batch_id]);
  
  //api call for battery tasks
  useEffect(() => {
    fetch(`/get_battery_tasks/${batch_id}`)
      .then((response) => response.json())
      .then((tasks) => {
        console.log("Tasks:", tasks);
        setTasks(tasks);
      })

  },[batch_id]);


  //api call for finished results tasks
  useEffect(() => {
    fetch(`/get_finished_results/${batch_id}`)
      .then((response) => response.json())
      .then((finished) => {
        console.log("Finished:", finished);
        setFinished(finished);
      })

  },[batch_id]);

  //api call for unfinished results tasks
  useEffect(() => {
    fetch(`/get_unfinished_results/${batch_id}`)
      .then((response) => response.json())
      .then((unfinished) => {
        console.log("Unfinished:", unfinished);
        setUnfinished(unfinished);
      })

  },[batch_id]);


  //api call for to be determined results tasks
  useEffect(() => {
    fetch(`/get_tbd_results/${batch_id}`)
      .then((response) => response.json())
      .then((tbd) => {
        console.log("TBD:", tbd);
        setTbd(tbd);
      })

  },[batch_id]);


  //api call for screening results tasks
  useEffect(() => {
    fetch(`/get_screening_results/${batch_id}`)
      .then((response) => response.json())
      .then((screening) => {
        console.log("Screening:", screening);
        setScreening(screening);
      })

  },[batch_id]);


  //function to read the number of true/false in screening
  const screening_func = (data, indicator) => {
    if (!Array.isArray(data) || data.length === 0) {
      return 'N/A'; // Return 'N/A' if there's no data
    }
    var count_of_indicator = 0;
    for( var j = 0; j < data.length; j ++){
      if(data[j].BatteryTasks[0] ==  indicator){
        count_of_indicator += 1;
      }
    }
    return count_of_indicator;
  };

    //function to determine who did something in tobe determined
    const tbd_func = (data, indicator) => {
      if (!Array.isArray(data) || data.length === 0) {
        return 'N/A'; // Return 'N/A' if there's no data
      }

      function checkInvalid(task){
        return !(task == 1 || task == 25 || task == 27);
      }

      var count_of_indicator = 0;
      var result = false;
      for( var j = 0; j < data.length; j ++){
        let tasks = data[j].result.split(",");
        let transformed_tasks = tasks.filter(checkInvalid);

        if(indicator == true){
          if(transformed_tasks.length > 0){
              count_of_indicator += 1;
              result = true;
          }
        }else if (indicator == false){
          if(transformed_tasks.length == 0){
            count_of_indicator += 1;
            result = false;
          }
        }
        //console.log(tasks, transformed_tasks, result , count_of_indicator)
        
      }
      return count_of_indicator;
    };

    return (
        <div className={styles.container}>
          <div>
            <h1>
              Welcome to the <br /> Activity Manager.
            </h1>
        
            <h2>Stats</h2>
            <div>

              <h4> # of People who clicked on the link: &nbsp;
              {Array.isArray(finished) &&
              Array.isArray(unfinished) &&
              Array.isArray(tbd)
              ? (finished.length + unfinished.length + tbd.length) : 'N/A'}
              </h4>

              <h5>
              &emsp; # of people who finished: &nbsp;
                {Array.isArray(finished)
              ? finished.length : 'N/A'}
              </h5>

              <h5>
              &emsp; # of people who did something: &nbsp;
                {Array.isArray(tbd)
              ? tbd_func(tbd,true) : 'N/A'}
              </h5>
              
              <h5>
              &emsp; # of people who did nothing: &nbsp;
                {Array.isArray(tbd)
              ? tbd_func(tbd,false) : 'N/A'}
              </h5>
              
              <h5>
              &emsp; # of people who failed/aborted: &nbsp;
                {Array.isArray(unfinished)
              ? unfinished.length : 'N/A'}
              </h5>

              <h5>
              &emsp; # of people who passed screening: &nbsp;
                {Array.isArray(screening)
              ? screening_func(screening, true) : 'N/A'}
              </h5>

              <h5>
              &emsp; # of people who failed screening: &nbsp;
                {Array.isArray(screening)
              ? screening_func(screening, false) : 'N/A'}
              </h5>

            </div>
          </div>
        </div>
      );

};
export default Activity;